import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgIf } from '@angular/common';
import { Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { DeviceSetting } from '../../../models/deviceSetting';

declare var plugin: any;

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css']
})
export class CameraComponent implements OnInit, AfterViewInit {

  @Input() video: DeviceSetting;
  @Input() index: string;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    console.log("ngOnInit ");
  }

  ngAfterViewInit() {
    console.log("ngAfterViewInit");
    let idName = "videoPlugin" + this.index;
    let url = "rtsp://" + this.video.deviceIP + ":554/ISAPI/Streaming/channels/";
    let a = plugin.startPlugin(idName, 0, url, 1, "b3BlcmF0b3I6T3BlcmF0b3IxMjM0IQ==");
  }
}
